import styled from 'styled-components';

import { Skeleton } from 'ui/skeleton';
import { colors, fontSizes, spacing } from 'ui/theme';

const displayText = {
  userId: 'User ID',
};

const Wrapper = styled.li`
  font-size: ${fontSizes.s12};
  color: ${colors.textSecondary};
  margin-bottom: ${spacing.base};
`;

const LoadingPlaceholder = styled(Skeleton)`
  display: inline-block;
  background-color: ${colors.grey5};
  width: ${spacing.x7};
  height: ${spacing.base};
`;

type ExternalIdProps = {
  externalId?: string;
  isLoading: boolean;
};

export const ExternalId = ({ externalId, isLoading }: ExternalIdProps) => {
  if (isLoading) {
    return (
      <Wrapper>
        <LoadingPlaceholder />
      </Wrapper>
    );
  }

  if (!externalId) {
    return null;
  }

  return (
    <Wrapper>
      {displayText.userId}: {externalId}
    </Wrapper>
  );
};
